import LoanSteps, { Props } from "./LoanSteps";

export default LoanSteps;
export type { Props };
